import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import store, { RootState } from '~/store'
import { DiffComment, upsertDiffComment } from '~/store/editorSlice'
import { useConversationUuid } from '../../../../hooks/conversation/useConversationUuid'

export function useReviewDiffCommentsWithRef(filePath?: string) {
  const conversationUuid = useConversationUuid()
  const review = useSelector((state: RootState) => state.editor.reviews[conversationUuid])
  const addComment = (uuid: string, comment: DiffComment) => {
    store.dispatch(upsertDiffComment({ uuid, comment }))
  }
  const comments =
    review?.diffComments?.filter(comment => {
      if (filePath == null) return true
      return comment.filePath === filePath
    }) ?? []

  const commentsRef = useRef(comments)
  useEffect(() => {
    commentsRef.current = comments
  }, [comments])

  return [comments, addComment, commentsRef] as const
}
